import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { Link } from 'gatsby';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "S-Mount Lenses",
  "path": "/Products/Lenses/S-Mount/",
  "dateChanged": "2017-12-12",
  "author": "Mike Polinowski",
  "excerpt": "INSTAR IP Camera Lense Upgrades",
  "image": "./P_SearchThumb_Products.png",
  "social": "/images/Search/P_SearchThumb_Products.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Lenses_white.webp",
  "chapter": "Products"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEOHelmet title='S-Mount Lenses' dateChanged='2017-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='INSTAR IP Camera Lense Upgrades' image='/images/Search/P_SearchThumb_Products.png' twitter='/images/Search/P_SearchThumb_Products.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationEN={props.location.pathname} locationDE='/de/Produkte/Objektive/S-Mount/' locationFR='/fr/Products/Lenses/S-Mount/' crumbLabel="S-Mount" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "s-mount-lenses",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#s-mount-lenses",
        "aria-label": "s mount lenses permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`S-Mount Lenses`}</h1>
    <ul>
      <li parentName="ul">
        <Link to="/Products/Lenses/S-Mount/IN-0180/" mdxType="Link">IN-0180</Link>
      </li>
      <li parentName="ul">
        <Link to="/Products/Lenses/S-Mount/IN-0220/" mdxType="Link">IN-0220</Link>
      </li>
      <li parentName="ul">
        <Link to="/Products/Lenses/S-Mount/IN-0290/" mdxType="Link">IN-0290</Link>
      </li>
      <li parentName="ul">
        <Link to="/Products/Lenses/S-Mount/IN-0360/" mdxType="Link">IN-0360</Link>
      </li>
      <li parentName="ul">
        <Link to="/Products/Lenses/S-Mount/IN-0430/" mdxType="Link">IN-0430</Link>
      </li>
      <li parentName="ul">
        <Link to="/Products/Lenses/S-Mount/IN-0600/" mdxType="Link">IN-0600</Link>
      </li>
      <li parentName="ul">
        <Link to="/Products/Lenses/S-Mount/IN-1200/" mdxType="Link">IN-1200</Link>
      </li>
      <li parentName="ul">
        <Link to="/Products/Lenses/S-Mount/IN-1600/" mdxType="Link">IN-1600</Link>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      